import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setViewedMinuteRequestAction } from 'core/actions';

interface IProps {
  videoUrl: string;
  eventId: number;
}

interface VkEmbedParams {
  oid: number;
  id: number;
}

const getEmbedParams = (url: string): VkEmbedParams | null => {
  const raw = (url || '').trim();
  if (!raw) return null;
  // Match video-123_456, video123_456, live-123_456, live123_456
  const match = raw.match(/(?:video|live)(-?\d+)_(\d+)/i);
  if (match) {
    const oid = parseInt(match[1], 10);
    const id = parseInt(match[2], 10);
    if (!Number.isNaN(oid) && !Number.isNaN(id)) {
      return { oid, id };
    }
  }
  return null;
};

export const VkVideo = ({ videoUrl, eventId }: IProps) => {
  const dispatch = useDispatch();
  const [viewedMinutes, setViewedMinutes] = useState(0);
  const [viewedSeconds, setViewedSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setViewedSeconds((s: number) => s + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setViewedMinutes(Math.floor(viewedSeconds / 60));
  }, [viewedSeconds]);

  useEffect(() => {
    if (viewedMinutes > 0) {
      dispatch(setViewedMinuteRequestAction(eventId));
    }
  }, [dispatch, viewedMinutes, eventId]);

  const params = getEmbedParams(videoUrl);
  if (!params) return null;

  const embedSrc = `https://vkvideo.ru/video_ext.php?oid=${params.oid}&id=${params.id}&hd=3`;

  return (
    <iframe
      src={embedSrc}
      frameBorder="0"
      allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock"
      allowFullScreen
      title="video"
    />
  );
};
